import React, { useState } from "react";
import linkedinLogo from "../../assets/linkedinLogo.png"; 
import websiteLogo from "../../assets/websiteLogo.png"; 
import emailLogo from "../../assets/emailLogo.png"; 
import googleScholarLogo from "../../assets/googleScholar.png"; 
import { motion, AnimatePresence } from "framer-motion";

// ================= Principal Investigator =================
const principleInvestigator = [
  {
    name: "Dr. Arjun Ray",
    imgSrc: require("../../assets/images/ArjunRay.png"),
    linkedin: "https://www.linkedin.com/in/arjunray/",
    profileLink: "https://www.iiitd.ac.in/arjun",
    googleScholar: "https://scholar.google.co.in/citations?user=reRjZdUAAAAJ&hl=en",
    emailId: "arjun@iiitd.ac.in",
  },
];

// ================= PhD / Postdoc / RA =================
const teamMembers = [
 
  
  {
    name: "Sadiyah Afroz",
    imgSrc: require("../../assets/images/sadiyah.jpg"),
    role: "Ph.D (2023-Present)",
    linkedin: "https://www.linkedin.com/in/sadiyah-afroz-17766b19b/",
  },
  {
    name: "Arvinpreet Kaur",
    imgSrc: require("../../assets/images/arvinpreet.jpg"),
    role: "Ph.D (2023-Present)",
    linkedin: "https://www.linkedin.com/in/arvinpreet-kaur-36b49416b",
  },
  {
    name: "Riddhi Sharma",
    imgSrc: require("../../assets/images/Riddhi.jpg"),
    role: "Ph.D (2023-Present)",
    linkedin: "https://www.linkedin.com/in/riddhi-sharma-a036931b9/",
  },
  {
    name: "Diksha Marwaha",
    imgSrc: require("../../assets/images/diksha.jpg"),
    role: "Ph.D (2023-Present)",
    linkedin: "https://www.linkedin.com/in/diksha-marwaha-1b7932150/",
  },
  {
    name: "Bhumika Choudhary",
    imgSrc: require("../../assets/images/bhumika.jpg"),
    role: "Ph.D (2024-Present)",
    linkedin: "https://www.linkedin.com/in/bhumika-choudhary-89b091207/",
  },
  {
    name: "Aishwary Sharma",
    imgSrc: require("../../assets/images/Aishwary.jpg"),
    role: "R.A (2024-2025)",
    working_at: "AI.cloud Engineer @TCS",
    linkedin: "https://www.linkedin.com/in/aish9413/",
  },
  {
    name: "Md. Khabeer Azhar",
    imgSrc: require("../../assets/images/Khabeer.jpg"),
    role: "Ph.D (2025-Present)",
    linkedin: "https://www.linkedin.com/in/khabeer-azhar/",
  },
  {
    name: "Anshu Gautam",
    imgSrc: require("../../assets/images/Anshu.jpg"),
    role: "Post-Doc (2025-Present)",
    linkedin: "https://www.linkedin.com/in/anshu-gautam-8239492a6/",
  },
  {
    name: "Deeksha Yadav",
    imgSrc: require("../../assets/images/Deeksha.jpeg"),
    role: "Ph.D (2025-Present)",
    linkedin: "https://www.linkedin.com/in/deeksha-yadav-80150b205/",
  },
  {
    name: "Bharat Kumar Sarvepalli",
    imgSrc: require("../../assets/images/Bharat.JPG"),
    role: "Industry-sponsored PhD (2025-Present)",
    linkedin: "https://www.linkedin.com/in/bharatsarvepalli/",
  },
];


// ================= M.Tech Present Students =================
const mtechPresent = [
  {
    name: "Heeram Hashmi",
    imgSrc: require("../../assets/images/heeram.jpeg"),
    role: "M.Tech (2025-Present)",
    linkedin: "https://www.linkedin.com/in/heeram-hashmi-5970a1207/",
  },
  {
    name: "Pratyush Singh",
    imgSrc: require("../../assets/images/pratyush.jpeg"),
    role: "M.Tech (2025-Present)",
    linkedin: "https://www.linkedin.com/in/pratyush-singh-963561212/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },
  {
    name: "Neha Jyoti",
    imgSrc: require("../../assets/images/neha_jyoti.jpeg"),
    role: "M.Tech (2025-present)",
    linkedin: "https://www.linkedin.com/in/neha-jyoti-2a163234b/",
  },
  
];

// ================= M.Tech Past Students =================
const mtechPast = [
  {
    name: "Bhumika Choudhary",
    imgSrc: require("../../assets/images/bhumika.jpg"),
    role: "M.Tech (2023-2024)",
    currentStatus: "PhD@IIITD"
  },
  {
    name: "Himanshi Garg",
    imgSrc: require("../../assets/images/himanshi.png"),
    role: "M.Tech (2022 - 2023)",
    currentStatus: "Data Analyst @Creyon Bio",
  },
  {
    name: "Shivansh Verma",
    imgSrc: require("../../assets/images/shivansh.jpg"),
    role: "M.Tech (2022 - 2023)",
    currentStatus: "Data Analyst @Creyon Bio",
  },
  {
    name: "Tushar Dhyani",
    imgSrc: require("../../assets/images/tushar_dhyani.png"),
    role: "M.Tech (2020 - 2021)",
    currentStatus: "Senior Bioinformatics Scientist at Elucidata"
  },
  {
    name: "Neha Mishra",
    imgSrc: require("../../assets/images/neha.jpeg"),
    role: "M.Tech (2019 - 2020)",
  },
];


// ================= B.Tech Students =================
const btechPresent = [
 
  { name: "G Sreeraj Mahesh", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2026-Present)" },
  
];

const btechPast = [
  { name: "Shashwat Chandra", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2025-2026)" },
  { name: "Shreyansh Seth", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2025-2026)" },
  { name: "Neil Mehta", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2025-2026)" },
  { name: "Saksham Saini", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2025-2026)" },
  { name: "Harsh Hingorani", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2025-2026)" },
  { name: "Idhant Arora", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2025-2026)" },
  { name: "Manveet Singh", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2025-2026)" },
  { name: "Harsh Rawat", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2025-2026)" },
  { name: "Karan Yadav", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2025-2026)" },
  { name: "Mayank Gautam", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2025-2026)" },
  { name: "Devanshu Chandela", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2025-2026)" },
  { name: "Akshat Tokas", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2025-2026)" },
  { name: "Shashank Gadamsetty", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2025-2026)" },
  { name: "Pratham Mittal", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2025-2026)" },
  { name: "Saurav Haldar", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2025-2026)" },
  { name: "Satyam", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2025-2026)" },
  { name: "Kartikeya Saini", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2024-2025)" },
  { name: "Kumar Aryan Singh", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2024-2025)" },
  { name: "Devesh Kumar Shaw", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2024-2025)" },
  { name: "Sparsh Sehgal", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2024-2025)" },
  { name: "Shyama Goel", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2024-2025)" },
  { name: "Shivam Choudhary", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2024-2025)" },
  { name: "Mandeep Singh Virdi", imgSrc: require("../../assets/images/mandeep.webp"), role: "B.Tech (2024-2025)" },
  { name: "Lovleen K Verma", imgSrc: require("../../assets/images/Lovleen.jpeg"), role: "B.Tech (2024-2025)", CurrentStatus: "SDE @ Microsoft", },
  { name: "Arnav Gupta", imgSrc: require("../../assets/images/Arnav.jpeg"), role: "B.Tech (2024-2025)", currentStatus: "SWE @ Scry-AI", },
  { name: "Ashwani", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2024-2025)" },
  { name: "Yaksh Mukesh Kumar Patel", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2024-2025)" },
  { name: "Yash Dhiman", imgSrc: require("../../assets/images/yash_dhiman.png"), role: "B.Tech (2024-2025)", currentStatus: "Masters @ University of Birmingham", },
  { name: "Nishi Ninawat", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2024-2025)" },
  { name: "Abhinav Arvind", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2024-2025)" },
  { name: "Varsha Bhaskar", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2024-2025)" },
  { name: "Ashwani", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2023-2024)" },
  { name: "Arun Yadav", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2023-2024)" },
  { name: "Ayush Prakash", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2023-2024)" },
  { name: "Praveen Singh Samota", imgSrc: require("../../assets/images/praveen.jpg"), role: "B.Tech (2023-2024)", currentStatus: "SDE-1 @ Zypp Electric", },
  { name: "Shubham Lal", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2023-2024)" },
  { name: "Vishnu Mothukuri", imgSrc: require("../../assets/images/vishnu.png"), role: "B.Tech (2023-2024)",  },
  { name: "Annu Kumari", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2023-2024)" },
  { name: "Shivanshu Pandey", imgSrc: require("../../assets/images/empty.jpg"), role: "B.Tech (2023-2024)", CurrentStatus: "MS Bioinformatics | Georgia Tech" },
  { name: "Mansi Chilkoti", imgSrc: require("../../assets/images/mansi.jpg"), role: "B.Tech (2023-2024)", currentStatus: "AI ML Computational Science Analyst @ Accenture", },
  { name: "Vaibhav Jaiswal", imgSrc: require("../../assets/images/vaibhav.JPG"), role: "B.Tech (2023-2024)", currentStatus: "SDE-I @ Urban Company", },
  { name: "Bhavay Aggarwal", imgSrc: require("../../assets/images/bhavay.jpg"), role: "B.Tech (2020-2021)", currentStatus: "PhD @ Georgia Tech", },
  { name: "Parth Garg", imgSrc: require("../../assets/images/parth.jpg"), role: "B.Tech (2020-2021)", currentStatus: "Software Engineer @ Microsoft", },
  { name: "Atul", imgSrc: require("../../assets/images/atul.jpeg"), role: "B.Tech (2020-2021)", currentStatus: "Senior Manager @ ICICI", },
  { name: "Mrinal", imgSrc: require("../../assets/images/Mrinal.jpg"), role: "B.Tech (2020-2021)", currentStatus: "Senior Software Engineer @ Newfold Digital", },
  { name: "Prutyay Gautam", imgSrc: require("../../assets/images/prutyam.jpg"), role: "B.Tech (2020-2021)", currentStatus: "Software Engineer @ Microsoft", },
];

// ================= Alumni =================
const alumniMembers = [
  {
    name: "Gayatri Panda",
    imgSrc: require("../../assets/images/gayatri.png"),
    role: "Ph.D (2020-2025)",
    currentStatus: "Senior Scientist @ Schrodinger",
    linkedin: "https://www.linkedin.com/in/gayatri-panda-44aa8215b/",
  },
  {
    name: "Sukriti Sacher",
    imgSrc: require("../../assets/images/sukriti.jpeg"),
    role: "Ph.D (2020-2026)",
    currentStatus: "Post-Doctoral Researcher @ Linköping University ",
    linkedin: "https://www.linkedin.com/in/sukriti-sacher-441424b1/",
  },
];



// ================= Components =================
const CardInvestigator = ({ name, imgSrc, linkedin, profileLink, googleScholar, emailId }) => (
  <div className="w-full max-w-sm bg-white border-2 mb-4 hover:shadow-lg transition duration-300 ease-in-out hover:scale-105 hover:border-designColor rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 flex flex-col">
    <div className="flex flex-col items-center pt-4 px-4">
      <img
        className="w-36 h-36 mb-3 shadow border-none shadow-lg object-cover rounded-lg"
        src={imgSrc}
        alt={name}
      />
      <h5 className="mb-1 text-2xl font-bold text-gray-900 dark:text-white text-center">{name}</h5>
      <span className="text-lg text-gray-700 dark:text-gray-300 py-1 text-center">Principal Investigator</span>
    </div>

    <div className="flex justify-center py-3 space-x-3 mt-auto">
      {linkedin && (
        <a href={linkedin} target="_blank" rel="noopener noreferrer">
          <img src={linkedinLogo} alt="LinkedIn" className="w-7 h-7" />
        </a>
      )}
      {profileLink && (
        <a href={profileLink} target="_blank" rel="noopener noreferrer">
          <img src={websiteLogo} alt="Website" className="w-7 h-7" />
        </a>
      )}
      {googleScholar && (
        <a href={googleScholar} target="_blank" rel="noopener noreferrer">
          <img src={googleScholarLogo} alt="Google Scholar" className="w-7 h-7" />
        </a>
      )}
      {emailId && (
        <a href={`mailto:${emailId}`} target="_blank" rel="noopener noreferrer">
          <img src={emailLogo} alt="Email" className="w-7 h-7" />
        </a>
      )}
    </div>
  </div>
);

const CardMember = ({ name, imgSrc, role, linkedin, currentStatus }) => (
  <div className="w-full max-w-sm bg-white border-2 mb-4 hover:shadow-lg transition duration-300 ease-in-out hover:scale-105 hover:border-designColor rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 flex flex-col">
    <div className="flex flex-col items-center pt-4 px-4">
      <img
        className="w-36 h-36 mb-3 shadow border-none shadow-lg object-cover rounded-lg"
        src={imgSrc}
        alt={name}
      />
      <h5 className="mb-1 text-xl font-semibold text-gray-900 dark:text-white text-center">{name}</h5>
      <span className="text-sm text-designColor py-1 text-center">{role}</span>
      {currentStatus && (
        <span className="text-sm text-gray-400 py-1 text-center">{currentStatus}</span>
      )}
    </div>

    {linkedin && (
      <div className="flex justify-center py-3 mt-auto">
        <a href={linkedin} target="_blank" rel="noopener noreferrer">
          <img src={linkedinLogo} alt="LinkedIn" className="w-6 h-6" />
        </a>
      </div>
    )}
  </div>
);

// ================= CollapsibleSection Component =================
const CollapsibleSection = ({ title, children, open = false }) => {
  const [isOpen, setIsOpen] = useState(open);

  return (
    <div className="my-6">
      <h2
        className="text-3xl font-bold text-center cursor-pointer text-designColor py-2"
        onClick={() => setIsOpen(!isOpen)}
      >
        {title}
      </h2>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

// ================= Team Component =================
const Team = () => {
  return (
    <section
      id="meet-the-team"
      className="max-w-screen-xl mx-auto w-full min-h-screen pb-8 py-8 text-lightText flex border-b-[1px] border-b-black"
    >
      <div className="flex flex-col gap-6 font-titleFont w-full">

        {/* Principal Investigator */}
        <h1 className="text-5xl font-bold text-designColor text-center mb-8">Principal Investigator</h1>
        <div className="max-w-[1240px] mx-auto grid place-items-center md:grid-cols-1 gap-8">
          {principleInvestigator.map((member, index) => (
            <CardInvestigator key={index} {...member} />
          ))}
        </div>

        {/* PhD / Postdoc / RA Section */}
        <CollapsibleSection title="Ph.D / Postdoc / RA Members" open>
          <div className="max-w-[1240px] mx-auto grid place-items-center md:grid-cols-3 gap-8 sm:grid-cols-1">
            {teamMembers.map((member, index) => (
              <CardMember key={index} {...member} />
            ))}
          </div>
        </CollapsibleSection>

        
{/* ================= M.Tech Section ================= */}
<CollapsibleSection title="M.Tech Students">

  {/* --- Present Students (Collapsible) --- */}
  <CollapsibleSection title={
    <span className="text-gray-500 text-lg font-semibold tracking-wide">Present Students</span>
  }>
    <div className="max-w-[1240px] mx-auto grid place-items-center md:grid-cols-3 gap-8 sm:grid-cols-1 mt-4">
      {mtechPresent.map((member, index) => (
        <CardMember key={index} {...member} />
      ))}
    </div>
  </CollapsibleSection>

  {/* --- Past Students (Collapsible) --- */}
  <CollapsibleSection title={
    <span className="text-gray-500 text-lg font-semibold tracking-wide">Past Students</span>
  }>
    <div className="max-w-[1240px] mx-auto grid place-items-center md:grid-cols-3 gap-8 sm:grid-cols-1 mt-4">
      {mtechPast.map((member, index) => (
        <CardMember key={index} {...member} />
      ))}
    </div>
  </CollapsibleSection>

</CollapsibleSection>




{/* ================= B.Tech Section ================= */}
<CollapsibleSection title="B.Tech Students">

  {/* --- Present Students (Collapsible) --- */}
  <CollapsibleSection
    title={
      <span className="text-gray-500 text-lg font-semibold tracking-wide">
        Present Students
      </span>
    }
  >
    <div className="max-w-[1240px] mx-auto grid place-items-center md:grid-cols-4 gap-8 sm:grid-cols-1 mt-4">
      {btechPresent.map((student, index) => (
        <CardMember key={index} {...student} />
      ))}
    </div>
  </CollapsibleSection>

  {/* --- Past Students (Collapsible) --- */}
  <CollapsibleSection
    title={
      <span className="text-gray-500 text-lg font-semibold tracking-wide">
        Past Students
      </span>
    }
  >
    <div className="max-w-[1240px] mx-auto grid place-items-center md:grid-cols-4 gap-8 sm:grid-cols-1 mt-4">
      {btechPast.map((student, index) => (
        <CardMember key={index} {...student} />
      ))}
    </div>
  </CollapsibleSection>

</CollapsibleSection>
{/* ================= Alumni Section ================= */}
<CollapsibleSection title="Alumni Members">
  <div className="max-w-[1240px] mx-auto grid place-items-center md:grid-cols-3 gap-8 sm:grid-cols-1 mt-4">
    {alumniMembers.map((member, index) => (
      <CardMember key={index} {...member} />
    ))}
  </div>
</CollapsibleSection>


      </div>
    </section>
  );
};

export default Team;